import React, { useEffect, useRef, useState } from "react";
import Recorder from "../../QuestionPage/recorder";
import AudioPlayer from "../../QuestionPage/AudioPlayer";
import ExamPanel from "../ExamPanel";

export default function SummarizeGroupDisscusionMockPage({
  question,
  onInputChange,
  questionNumber,
  ...props
}) {
  const [text, setText] = useState("");
  const [audioLink, setAudioLink] = useState("");
  const audioRef = useRef(null);

  useEffect(() => {
    const fetchSignedUrl = async () => {
      try {
        const res = await fetch(question.media_link);
        const data = await res.json();
        setAudioLink(data.url);
        if (audioRef.current) {
          audioRef.current.pause();
          audioRef.current.currentTime = 0;
        }
      } catch (err) {
        console.error("Failed to fetch signed audio URL:", err);
      }
    };

    if (question?.media_link) fetchSignedUrl();
  }, [question]);

  const handleTextChange = (newText) => {
    if (newText !== text) {
      setText(newText);
      onInputChange(newText);
    }
  };

  return (
    <ExamPanel
      eyebrow="Speaking"
      title="Summarize Group Discussion"
      questionLabel={`Question ${questionNumber} of 36`}
      instructions="You will hear three people having a discussion. When you hear the beep, summarize the whole discussion."
    >
      <div className="grid gap-6 lg:grid-cols-[minmax(280px,1fr),420px] lg:items-start">
        <div className="rounded-md border border-slate-200 bg-slate-50 p-5">
          {audioLink ? (
            <AudioPlayer audioSrc={audioLink} audioRef={audioRef} />
          ) : (
            <p className="text-sm font-semibold text-gray-500">Loading audio...</p>
          )}
        </div>

        <div className="rounded-md border border-slate-200 bg-white p-4">
          <Recorder
            key={question?._id || questionNumber}
            text={text}
            setText={handleTextChange}
            {...props}
            duration={120}
            className="min-h-56 w-full rounded-md border border-slate-200 bg-slate-50"
          />
        </div>
      </div>
    </ExamPanel>
  );
}
